module.exports = __webpack_public_path__ + "static/media/Optiflo.547e6a74.jpg";